export default __webpack_public_path__ + "static/brushstroke-7bb9b8553fbdb9bf020fd68fded77aaa.svg";